import React from "react";
import { motion } from "framer-motion";

const SkeletonCard = () => (
  <div className="flex justify-between items-center p-4 border border-slate-700 rounded-2xl my-2 shadow-sm bg-slate-800/50 animate-pulse">
    <div className="w-full">
      <div className="h-4 bg-slate-700 rounded w-3/4 mb-4"></div>
      <div className="h-3 bg-slate-700 rounded w-1/4"></div>
    </div>
    <div className="w-20 h-10 bg-slate-700 rounded-md ml-4"></div>
  </div>
);

const TaskSkeleton = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="container mx-auto py-20 px-4 flex flex-col"
    >
      {/* Skeleton for Tabs */}
      <div className="flex justify-center mb-6">
        <div className="h-10 bg-slate-700 rounded-full w-2/3 animate-pulse"></div>
      </div>

      {/* Skeleton for Task List */}
      <div className="my-6">
        <div className="h-6 bg-slate-700 rounded w-1/3 mb-3 animate-pulse"></div>
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    </motion.div>
  );
};

export default TaskSkeleton;